import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import store from './store';
import VueMask from 'v-mask';
import myApi from './gavnoCode/ApiHandler';

Vue.config.productionTip = false;
Vue.use(VueMask);
Vue.prototype.$myApi = myApi;

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
